import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { ButtonProps } from 'features/ui/elements';
import { Button } from 'features/ui/elements';

export const CallDetailsSkipToSignMailButton: FC<
  Pick<ButtonProps, 'onClick' | 'loading'>
> = ({ onClick, loading }) => {
  const { t } = useTranslation();

  return (
    <Button
      fullWidth
      size='small'
      color='secondary'
      onClick={onClick}
      loading={loading}
    >
      {t('signMail.skipToSignMail')}
    </Button>
  );
};
